export type AIMMEpisode = {
  num: string;
  title: string;
  meta: string[];
};

export const AIMM_EPISODES: readonly AIMMEpisode[] = [
  { num: '037', title: 'Are we underestimating context windows?', meta: ['28 min', 'Apr 2026', '12k views'] },
  { num: '036', title: 'When prompt engineering became real engineering', meta: ['22 min', 'Mar 2026', '9.4k views'] },
  { num: '035', title: 'The case against AI code review', meta: ['19 min', 'Mar 2026', '14k views'] },
  { num: '034', title: 'What "agentic" actually means in practice', meta: ['25 min', 'Feb 2026', '8.1k views'] },
];
